export const GET_AISLES = "GET_AISLES";
export const GET_AISLE_BY_ID = "GET_AISLE_BY_ID";
export const UPDATE_AISLE = "UPDATE_AISLE";
export const DELETE_AISLE = "DELETE_AISLE";
export const CREATE_AISLE = "CREATE_AISLE";
